import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const GDPRComplianceNotice = ({ onAcceptanceChange, isAccepted }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleAcceptanceChange = (e) => {
    onAcceptanceChange(e.target.checked);
  };

  const toggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="bg-secondary-50 rounded-lg p-4 border border-secondary-200">
      {/* Header */}
      <div className="flex items-start space-x-3 mb-3">
        <div className="flex-shrink-0 mt-0.5">
          <Icon name="Shield" size={20} color="var(--color-primary)" />
        </div>
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-text-primary font-inter mb-1">
            Protection de vos données personnelles
          </h3>
          <p className="text-xs text-text-secondary font-inter">
            Conformément au RGPD, nous nous engageons à protéger vos informations personnelles.
          </p>
        </div>
      </div>

      {/* Expandable Content */}
      <div className={`overflow-hidden transition-all duration-300 ${isExpanded ? 'max-h-96' : 'max-h-0'}`}>
        <div className="pt-2 border-t border-secondary-200 space-y-3">
          <div className="text-xs text-text-secondary font-inter space-y-2">
            <p>
              <strong>Collecte des données :</strong> Nous collectons uniquement les informations nécessaires 
              à la vérification de votre identité et à la communication avec vous.
            </p>
            <p>
              <strong>Utilisation :</strong> Vos données sont utilisées exclusivement pour :
            </p>
            <ul className="list-disc list-inside ml-2 space-y-1">
              <li>Vérifier votre identité</li>
              <li>Vous contacter concernant votre demande</li>
              <li>Respecter nos obligations légales</li>
            </ul>
            <p>
              <strong>Conservation :</strong> Vos données sont conservées pendant la durée nécessaire 
              au traitement de votre demande, puis supprimées selon notre politique de rétention.
            </p>
            <p>
              <strong>Vos droits :</strong> Vous disposez d'un droit d'accès, de rectification, 
              d'effacement et de portabilité de vos données.
            </p>
          </div>
        </div>
      </div>

      {/* Toggle Button */}
      <button
        onClick={toggleExpanded}
        className="flex items-center space-x-2 text-xs text-primary font-medium font-inter mt-2 hover:text-primary-600 transition-smooth focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 rounded"
      >
        <span>{isExpanded ? 'Masquer les détails' : 'Voir les détails'}</span>
        <Icon 
          name={isExpanded ? 'ChevronUp' : 'ChevronDown'} 
          size={14} 
        />
      </button>

      {/* Acceptance Checkbox */}
      <div className="flex items-start space-x-3 mt-4 pt-3 border-t border-secondary-200">
        <div className="flex items-center h-5">
          <input
            type="checkbox"
            id="gdpr-acceptance"
            checked={isAccepted}
            onChange={handleAcceptanceChange}
            className="w-4 h-4 text-primary border-border rounded focus:ring-primary focus:ring-2"
          />
        </div>
        <label htmlFor="gdpr-acceptance" className="flex-1 text-xs text-text-primary font-inter cursor-pointer">
          J'accepte que mes données personnelles soient traitées conformément à la politique de confidentialité et aux conditions d'utilisation de deepblock.
          <br/>Je comprends mes droits concernant mes données personnelles. *
        </label>
      </div>

      {/* Contact Information */}
      <div className="mt-3 pt-2 border-t border-secondary-200">
        <div className="flex items-center space-x-2 text-xs text-text-secondary font-inter">
          <Icon name="Mail" size={12} />
          <span>
            Pour toute question : <a href="mailto:contact@deepblock.eu" className="text-primary hover:underline">contact@deepblock.eu</a>
          </span>
        </div>
      </div>
    </div>
  );
};

export default GDPRComplianceNotice;